import { Pipe, PipeTransform } from '@angular/core';
import { formatNumber } from '@angular/common';

/**
 * Pipe pour formater les entiers (notamment les numéros de commande / sales_order.id)
 * avec le séparateur français (espace).
 *
 * Exemples :
 * - 624637 => "624 637"
 * - "624637" => "624 637"
 */
@Pipe({
  name: 'formatInteger',
  standalone: true,
})
export class FormatIntegerPipe implements PipeTransform {
  transform(value: any): string {
    if (value !== undefined && value !== null && value !== '' && !isNaN(Number(value))) {
      return formatNumber(Number(value), 'fr', '1.0-0');
    }
    return value !== null && value !== undefined ? String(value) : '';
  }
}
